import type {
  LoadFiguresSource,
  ShortCircuitPowerSource,
} from "../services/powerQualityContract";
import type { ValidationLabels } from "../utils/validationMessages";

// On-screen labels of the power factor correction form (EOS-11a, A32), keyed by the request
// path. The run request nests the study under "study", so every study path carries that
// prefix. The report's inputs section names a stored field the way the form does.
export const PF_CORRECTION_LABELS: ValidationLabels = {
  fields: {
    "study.code": "Study code",
    "study.name": "Study name",
    "study.bus_code": "Bus code",
    "study.system_nominal_voltage_v": "System nominal voltage (V)",
    "study.frequency_hz": "Frequency (Hz)",
    "study.load_run_id": "Load run",
    "study.typed_load": "Load figures source",
    "study.typed_load.active_power_kw": "Active power P (kW)",
    "study.typed_load.present_power_factor": "Present power factor",
    "study.typed_load.source": "Load figures source text",
    "study.target_power_factor": "Target power factor",
    "study.bank": "Capacitor bank",
    "study.bank.rated_voltage_v": "Capacitor rated voltage (V)",
    "study.bank.declared_rating_kvar": "Declared bank rating (kvar)",
    "study.bank.step_sizes_kvar": "Step sizes (kvar)",
    "study.bank.step_sizes_kvar.*": "Step size (kvar)",
    "study.reactor_ratio_percent": "Detuned reactor ratio p (%)",
    "study.fault_run_id": "Fault run",
    "study.typed_short_circuit_power": "Short-circuit power source",
    "study.typed_short_circuit_power.short_circuit_power_kva": "Short-circuit power S_sc (kVA)",
    "study.typed_short_circuit_power.source": "Short-circuit power source text",
    "study.characteristic_orders": "Characteristic harmonic orders",
    "study.characteristic_orders.*": "Characteristic harmonic order",
    "study.jurisdiction_profile": "Jurisdiction profile",
    notes: "Study notes",
  },
};

// The words of every source the result echoes, typed against the contract enums so a value
// the contract gains cannot pass without a label.
export const LOAD_SOURCE_LABELS: Record<LoadFiguresSource, string> = {
  LINKED_LOAD_RUN: "Linked load run",
  TYPED: "Typed value",
};

export const SHORT_CIRCUIT_SOURCE_LABELS: Record<ShortCircuitPowerSource, string> = {
  LINKED_FAULT_RUN: "Linked fault run",
  TYPED: "Typed value",
};
